import { Button, Stack, styled } from '@mui/material';

export const RedactButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.5, 1),
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.warning.dark,
  },
}));

export const RedactionControls = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'row',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
}));
